import { render, staticRenderFns } from "./ConfigContainer.vue?vue&type=template&id=c9859a04&scoped=true"
import script from "./ConfigContainer.vue?vue&type=script&lang=js"
export * from "./ConfigContainer.vue?vue&type=script&lang=js"
import style0 from "./ConfigContainer.vue?vue&type=style&index=0&id=c9859a04&prod&scoped=true&lang=scss"
import style1 from "./ConfigContainer.vue?vue&type=style&index=1&id=c9859a04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9859a04",
  null
  
)

export default component.exports